<template>
    <div :class="{focus: focused}" class="text-editor">
        <div ref="text" style="height: 200px;"></div>
    </div>
</template>
<style>
.mce-toolbar-grp {
    height: 0;
    padding: 0;
    overflow: hidden;
    transition: 300ms;
}

.focus .mce-toolbar-grp {
    height: 32px;
}

.mce-panel {
    border: 0;
}

.text-editor {
    border: 1px solid #ebedf2;
    overflow: hidden;
    border-radius: 4px;
}
div.mce-fullscreen {
    top: 70px;
}
</style>
<script>
// https://github.com/tinymce/tinymce/issues/2836
import tinymce from 'tinymce/tinymce';
import 'tinymce/themes/modern/theme';
// plugins
import 'tinymce/plugins/link/plugin';
import 'tinymce/plugins/autolink/plugin';
import 'tinymce/plugins/paste/plugin';
import 'tinymce/plugins/autoresize/plugin';
import 'tinymce/plugins/media/plugin';
import 'tinymce/plugins/image/plugin';
import 'tinymce/plugins/code/plugin';
import 'tinymce/plugins/fullscreen/plugin';
import 'tinymce/plugins/wordcount/plugin';
import 'tinymce/plugins/lists/plugin';
import 'tinymce/plugins/spellchecker/plugin';
import 'tinymce/plugins/imagetools/plugin';


// Upload image: https://www.tinymce.com/docs/get-started/upload-images/

export default {
    props: ['value'],
    data() {
        return {
            focused: false
        };
    },
    watch: {
        value() {
            if (!this.editor) return;
            this.setValue(this.value);
        },
    },
    methods: {
        setValue(value) {
            if (value == this.editor.getContent()) {
                return;
            }
            value = (this.value === null || this.value === undefined) ? '' : this.value;
            this.editor.setContent(value);
        }
    },
    mounted() {
        const textEditor = this;
        tinymce.init({
            target: this.$refs.text,
            skin: false,
            menubar: true,
            statusbar: true,
            relative_urls: false,
            wordcount_cleanregex: /[0-9.(),;:!?%#$?\x27\x22_+=\\/-]*/g,
            plugins: [
                'autolink link image media paste code fullscreen lists wordcount spellchecker imagetools'
            ],
            toolbar: 'undo redo | link image imagetools | insert | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent |  code | numlist bullist | spellchecker | imagetools',
            media_live_embeds: true,
            content_css: '/css/tinymceCustom.css',

            browser_spellcheck: true,
            contextmenu: false,
            autoresize_bottom_margin: 0,
            images_upload_url: '/tinymce-upload-image',
            branding: false,
            file_picker_types: 'image',
            imagetools_toolbar: 'rotateleft rotateright | flipv fliph | editimage imageoptions',
            paste_data_images: true,
            image_caption: false,
            image_title: true,
            imagetools_cors_hosts: ['amazonaws.com', 's3-eu-west-1.amazonaws.com', 'localhost'],
            automatic_uploads: true,
            image_advtab: true,
            setup (newEditor) {
                newEditor.on('init', () => {
                    textEditor.editor = newEditor;

                    textEditor.setValue(textEditor.value);

                    textEditor.editor.on('change', () => {
                        textEditor.$emit('input', textEditor.editor.getContent());
                    });
                    textEditor.editor.on('focus', () => {
                        textEditor.focused = true;
                    });
                    textEditor.editor.on('blur', () => {
                        textEditor.focused = false;
                    });

                });
            },
        });
    }

};
</script>


// WEBPACK FOOTER //
// resources/js/ui/TextEditor.vue